import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '../../shared/Switch';
import Dropdown from '../../shared/Dropdown';
import { color } from '../../../app/theme';
import { GameType, LoginResultAwardMethod } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    content: {
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'space-between',
      backgroundColor: color.$19,
      borderRadius: '24px',
      padding: '12px 16px',
      width: 615,
    },
    subtitle: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$11,
    },
    error: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$17,
      marginTop: 8,
    },
    selectBlock: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  {
    name: 'Coupon',
  },
);

const Coupon = ({
  isSaved,
  data,
  onMethodChange,
  onTypeChange,
  onCouponSetIdChange,
  onEnable,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { couponList, gameList } = useSelector(store => store.main);
  const { method, gameType, value, enabled } = data || {};

  const gameItems = [
    {
      text: t('recurringMessage:roulette'),
      value: GameType.ROULETTE,
    },
    {
      text: t('recurringMessage:scratch'),
      value: GameType.SCRATCH,
    },
    {
      text: t('recurringMessage:slotmachine'),
      value: GameType.SLOTMACHINE,
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {t('recurringMessage:loginResultSuccessAward')}
      </div>
      <div className={classes.content}>
        <div style={{ width: '100%' }}>
          <div className={classes.subtitle}>
            {t('recurringMessage:loginResultSuccessAwardSubTitle')}
          </div>
          <div className={classes.subtitle}>
            {t('recurringMessage:loginResultSuccessAwardSubTitle2')}
          </div>
          <div className={classes.subtitle}>
            {t('recurringMessage:loginResultSuccessAwardSubTitle3')}
          </div>
          {!(couponList || []).length && !(gameList || []).length && (
            <div className={classes.error}>
              {t('recurringMessage:loginResultSuccessAwardError')}
            </div>
          )}
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="default-display"
              name="default-display"
              value={method}
              onChange={e => onMethodChange(e?.target?.value)}
            >
              <FormControlLabel
                className={classes.option}
                classes={{
                  label: classes.radioInput,
                }}
                value={LoginResultAwardMethod.COUPON}
                control={<Radio color="primary" />}
                label={t('recurringMessage:loginResultSuccessAwardCoupon')}
                disabled={!enabled}
              />
              <FormControlLabel
                className={classes.option}
                classes={{
                  label: classes.radioInput,
                }}
                value={LoginResultAwardMethod.GAME}
                control={<Radio color="primary" />}
                label={t('recurringMessage:loginResultSuccessAwardGame')}
                disabled={!enabled}
              />
            </RadioGroup>
          </FormControl>
          {method === LoginResultAwardMethod.COUPON && (
            <div className={classes.selectBlock}>
              <Dropdown
                name="plan-dropdown"
                className={classes['plan-dropdown']}
                placeholder={t(
                  'recurringMessage:loginResultSuccessAwardCouponPlaceholder',
                )}
                menuItems={couponList.map(c => ({
                  text: c?.couponName,
                  value: c?.couponSetId,
                }))}
                value={value || undefined}
                onChange={onCouponSetIdChange}
                style={{
                  width: 320,
                  border:
                    isSaved && !value && enabled
                      ? `1px solid ${color.$17}`
                      : `1px solid ${color.$10}`,
                }}
                disabled={!enabled}
              />
            </div>
          )}
          {method === LoginResultAwardMethod.GAME && (
            <div className={classes.selectBlock}>
              <Dropdown
                name="plan-dropdown"
                menuItems={gameItems}
                placeholder={t(
                  'recurringMessage:loginResultSuccessAwardGameTypePlaceholder',
                )}
                value={gameType || undefined}
                onChange={onTypeChange}
                style={{
                  width: 210,
                  marginRight: 8,
                }}
                disabled={!enabled}
              />
              <Dropdown
                name="plan-dropdown"
                className={classes['plan-dropdown']}
                placeholder={t(
                  'recurringMessage:loginResultSuccessAwardGamePlaceholder',
                )}
                menuItems={gameList
                  .filter(g => {
                    if (gameType === 'slotmachine') {
                      return g?.gameType === 'slot';
                    }

                    return g?.gameType === gameType;
                  })
                  .map(g => ({ text: g?.name, value: g?.id }))}
                value={value || undefined}
                onChange={onCouponSetIdChange}
                style={{
                  width: 290,
                  border:
                    isSaved && !value && enabled
                      ? `1px solid ${color.$17}`
                      : `1px solid ${color.$10}`,
                }}
                disabled={!enabled}
              />
            </div>
          )}
        </div>
        <div>
          <Switch
            checked={enabled}
            onClick={() => {
              if (!(couponList || []).length && !(gameList || []).length) {
                onEnable(false);
              } else {
                onEnable(!enabled);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Coupon;
